const countryList = [
  {
    key: 'All',
    value: 'All countries',
    code: '-1',
  },
  {
    key: 'Austria',
    value: 'Austria',
    code: '10',
  },
  {
    key: 'Belgium',
    value: 'Belgium',
    code: '14',
  },
  {
    key: 'Bulgaria',
    value: 'Bulgaria',
    code: '26',
  },
  {
    key: 'Croatia',
    value: 'Croatia',
    code: '49',
  },
  {
    key: 'Cyprus',
    value: 'Republic of Cyprus',
    code: '207',
  },
  {
    key: 'Czech',
    value: 'Czech Republic',
    code: '51',
  },
  {
    key: 'Denmark',
    value: 'Denmark',
    code: '53',
  },
  {
    key: 'Estonia',
    value: 'Estonia',
    code: '61',
  },
  {
    key: 'Finland',
    value: 'Finland',
    code: '65',
  },
  {
    key: 'France',
    value: 'France',
    code: '66',
  },
  {
    key: 'Germany',
    value: 'Germany',
    code: '72',
  },
  {
    key: 'Greece',
    value: 'Greece',
    code: '76',
  },
  {
    key: 'Hungary',
    value: 'Hungary',
    code: '88',
  },
  {
    key: 'Iceland',
    value: 'Iceland',
    code: '89',
  },
  {
    key: 'Ireland',
    value: 'Ireland',
    code: '92',
  },
  {
    key: 'Italy',
    value: 'Italy',
    code: '93',
  },
  {
    key: 'Latvia',
    value: 'Latvia',
    code: '104',
  },
  {
    key: 'Liechtenstein',
    value: 'Liechtenstein',
    code: '107',
  },
  {
    key: 'Lithuania',
    value: 'Lithuania',
    code: '108',
  },
  {
    key: 'Luxembourg',
    value: 'Luxembourg',
    code: '109',
  },
  {
    key: 'Malta',
    value: 'Malta',
    code: '115',
  },
  {
    key: 'Netherlands',
    value: 'Netherlands',
    code: '129',
  },
  {
    key: 'Norway',
    value: 'Norway',
    code: '139',
  },
  {
    key: 'Poland',
    value: 'Poland',
    code: '151',
  },
  {
    key: 'Portugal',
    value: 'Portugal',
    code: '152',
  },
  {
    key: 'Romania',
    value: 'Romania',
    code: '226',
  },
  {
    key: 'Slovakia',
    value: 'Slovakia',
    code: '165',
  },
  {
    key: 'Slovenia',
    value: 'Slovenia',
    code: '167',
  },
  {
    key: 'Spain',
    value: 'Spain',
    code: '170',
  },
  {
    key: 'Sweden',
    value: 'Sweden',
    code: '175',
  },
];

const countryCodeMap = {
  Austria: '10',
  Belgium: '14',
  Bulgaria: '26',
  Croatia: '49',
  'Republic of Cyprus': '207',
  'Czech Republic': '51',
  Denmark: '53',
  Estonia: '61',
  Finland: '65',
  France: '66',
  Germany: '72',
  Greece: '76',
  Hungary: '88',
  Ireland: '92',
  Italy: '93',
  Latvia: '104',
  Lithuania: '108',
  Luxembourg: '109',
  Malta: '115',
  Netherlands: '129',
  Poland: '151',
  Portugal: '152',
  Romania: '226',
  Slovakia: '165',
  Slovenia: '167',
  Spain: '170',
  Sweden: '175',
  Iceland: '89',
  Liechtenstein: '107',
  Norway: '139',
};

export {
  countryList,
  countryCodeMap,
};
